<template>
    <div
        ref="searchbar"
        class="mb-4 flex items-center gap-1"
    >
        <div class="relative flex grow items-center">
            <input
                v-model="store.searchInput"
                type="text"
                :placeholder="$t('klok.search_placeholder')"
                class="w-full rounded-none border-b border-black-text py-2 text-sm"
                @keyup.enter="handleSearchInput"
                @keyup.escape="areSuggestionsVisible = false"
            />
            <i
                v-show="store.isFetching"
                class="pi pi-spin pi-spinner absolute right-2"
            />
        </div>
        <div
            class="flex cursor-pointer"
            @click="handleSearchInput"
        >
            <Icon
                name="custom:search"
                size="1.125rem"
            />
        </div>
        <teleport to="body">
            <div
                v-show="
                    areSuggestionsVisible &&
                    store.filteredSuggestions.length > 0
                "
                ref="suggestions"
                class="fixed z-[999] flex max-h-96 w-full max-w-72 translate-y-2 flex-col divide-y divide-black-text overflow-hidden border border-black-text bg-white"
            >
                <div
                    v-for="locality in store.filteredSuggestions"
                    :key="locality.id"
                    class="cursor-pointer p-2 hover:font-promedium hover:text-hover-link"
                    @click="handleSuggestionClick(locality.nazev)"
                >
                    {{ locality.cislo }} -
                    {{ locality.nazev }}
                </div>
            </div>
        </teleport>
    </div>
</template>

<script lang="ts" setup>
const store = useKlokStore()

const searchbar = ref<HTMLElement | null>(null)
const suggestions = ref<HTMLElement | null>(null)
const areSuggestionsVisible = ref(false)

function handleSearchInput() {
    areSuggestionsVisible.value = false
    store.searchedLocality = store.searchInput
}

function handleSuggestionClick(locality: string) {
    areSuggestionsVisible.value = false
    store.searchInput = locality
    store.searchedLocality = locality
}

watch(
    () => store.searchInput,
    () => {
        if (store.searchInput.length > 2) {
            findCorrectCoordinates()
            areSuggestionsVisible.value = true
            if (store.searchedLocality === store.searchInput) {
                areSuggestionsVisible.value = false
            }
        } else {
            areSuggestionsVisible.value = false
        }
    }
)

onClickOutside(searchbar, () => {
    areSuggestionsVisible.value = false
})

function findCorrectCoordinates() {
    if (searchbar.value && suggestions.value) {
        const searchbarRect = searchbar.value.getBoundingClientRect()
        suggestions.value.style.top = `${searchbarRect.bottom}px`
        suggestions.value.style.left = `${searchbarRect.left}px`
    }
}
</script>

<style scoped></style>
